// extracted by mini-css-extract-plugin
export default {"list":"Ppf_list__w0BfN","tab":"Ppf_tab__o9kXK"};